import { Flex } from '@chakra-ui/react';
import { CenterSpinner, Table as DrilldownTable } from '@/components/ats';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

export const ActivitiesTable = ({
  data = [],
  totalCount = 0,
  currentDrillPage = 1,
  handleLoadMore = () => {},
  columnConfig = [],
  isLoadingMore = false,
}) => {
  const scrollRef = useBottomScrollListener(handleLoadMore, {
    offset: 100,
    debounce: 1000,
  });

  return (
    <Flex flexDir="column" flex={1}>
      <DrilldownTable
        tableRef={scrollRef}
        columns={columnConfig}
        data={data}
        skipPagination={true}
        pagination={{
          total: totalCount,
          count: data?.length,
          limit: 50,
        }}
        paginationLimit={50}
        page={{ number: currentDrillPage }}
        applyPage={handleLoadMore}
        enableLoadMore={false}
        isLoadingMore={isLoadingMore}
        layoutStyles={{
          borderBottomWidth: '0px',
        }}
      />
      {isLoadingMore && data?.length >= 50 && (
        <Flex my="5px" justifyContent="center">
          <CenterSpinner h="50px" />
        </Flex>
      )}
    </Flex>
  );
};
